import { UnavailabilityError } from 'expo-modules-core';

export default function withNativeAd() {
  throw new UnavailabilityError('expo-ads-facebook', 'withNativeAd');
}
